var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"mx-2",attrs:{"outlined":"","rounded":"","clearable":"","hide-details":"","append-icon":"mdi-magnify","dense":"","label":"Search"},on:{"input":function($event){return _vm.$emit('search', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }